import EventDetails from './event-details';
export default EventDetails;
